import httpRequest from "@/infra/httpRequest";
import GetCompanyDTO from "@/application/dto/companies/GetCompanyDTO";

export default class CompaniesRepository {
    public async getBySlug(slug: string): Promise<GetCompanyDTO> {
        try {
            const { data: { company } } = await httpRequest.get(`/companies/slug/${slug}`);
            return new GetCompanyDTO(
                company.company_id,
                company.name,
                company.logo,
                company.banner,
                company.text_content,
                company.script_content
            );
        } catch (err) {
            throw Error;
        }
    }
}